
import { ADD_TO_CART,REMOVE_ITEM,SUB_QUANTITY,ADD_QUANTITY,SET_USER,SET_PRODUCT,SET_PROD,SEND_DATA, HANDLE_DETAILS,SET_NAME} from './action-types/cart-actions'

//add cart action
export const addToCart= (key)=>{
    return{
        type: ADD_TO_CART,
        key,
        
        
    }
}
//remove item action
export const removeItem=(key)=>{
    return{
        type: REMOVE_ITEM,
        key
    }
}
//subtract qt action
export const subtractQuantity=(key)=>{
    return{
        type: SUB_QUANTITY,
        key
    }
}
//add qt action
export const addQuantity=(key)=>{
    return{
        type: ADD_QUANTITY,
        key
    }
}

export const setUser=({ name })=> {
    return {
      type:SET_USER,
      name,      // User name
    }
  }


  export const setProduct=({ keys,owner,p_name,price,quantity,category,info,img })=> {
    return {
      type:SET_PRODUCT,
      keys,	
      owner,
      p_name,
      price,
      quantity,	
      category,	
      info,
      img

    }
  }


  export const setProd= (itemr)=>{
    return{
        type: SET_PROD,
        itemr,
    }
}

export const sendData= (key)=>{
    return{
        type: SEND_DATA,
        key,
    }
}


export const handleDetails= (key)=>{
    return{
        type: HANDLE_DETAILS,
        key,
    }
}

export const setName= (name)=>{
    return{
        type: SET_NAME,
        name,
    }
}